var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"navigation-button",class:_vm.navigationClass,attrs:{"disabled":!_vm.isDisabled()},on:{"click":function($event){return _vm.updateTableNavigation()}}},[_c('i',{class:_vm.getOptionNameIcon()}),_vm._v(" "+_vm._s(this.$t(`label.${_vm.navigationItem.id}`))+" "+_vm._s(_vm.tableDataLength())+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }